import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer
} from 'recharts';

export const Sparkline = ({ data, dataKey, color, width = '100%', height = 30, tooltipFormatter }) => {
    const values = data.map(item => item[dataKey]);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const domain = [min - Math.abs(min * 0.1), max + Math.abs(max * 0.1)];

    return (
        <ResponsiveContainer width={width} height={height}>
            <LineChart data={data}>
                <XAxis dataKey="date" hide={true} />
                <Line
                    type="monotone"
                    dataKey={dataKey}
                    stroke={color}
                    strokeWidth={2}
                    dot={false}
                    isAnimationActive={false}
                />
                <YAxis hide domain={domain} />
                <Tooltip formatter={tooltipFormatter} />
            </LineChart>
        </ResponsiveContainer>
    );
};